import { Component, computed, inject, OnChanges, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingService } from './core/services/loading.service';
import { LoaderComponent } from './component/loader/loader.component';
import { AuthService } from './core/services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  imports: [ RouterModule,LoaderComponent,CommonModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent  {
    loadingService = inject(LoadingService);
    title = 'Gestione Sottoscrizioni';
    private authService = inject(AuthService);
    userSignal = this.authService.getUserSignal();
    logged = computed(() => !!this.userSignal());



    logout(){
      this.authService.logOut();
    }
}
